var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-form',[_c('FormInput',{attrs:{"type":'text',"label":'Campaign Title',"name":'title',"placeholder":'e.g spotify ad'},on:{"handleInput":_vm.handleInput}}),_c('FormInput',{attrs:{"type":'text',"label":'Campaign Copy',"name":'description',"placeholder":'describe your campaign'},on:{"handleInput":_vm.handleInput}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }